(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsGenericMultiSelect', rmsGenericMultiSelect);

    function rmsGenericMultiSelect(lodash, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                onChange: '=',
                label: '=',
            },
            controller: rmsGenericMultiSelectCtrl,
            controllerAs: "vm",
            templateUrl: 'common/app/components/generic-multi-select',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.setModelValue = setModelValue;

                // ctrl.$formatters.push(function (modelValue) {
                //     return modelValue;
                // });

                ctrl.$render = function () {
                    vm.options = scope.options.map(function (option) {
                        var requiredTemplate = '&nbsp;<i class="fa fa-lock fa-inherit-color" aria-hidden="true"></i>'
                        if (option.required && !option.label.includes(requiredTemplate) ) {
                            option.label += requiredTemplate;
                        }

                        return option;
                    });

                    vm.selected = ctrl.$viewValue;
                };

                function setModelValue(value) {
                    return ctrl.$setViewValue(value);
                }
            }
        };
    }

    function rmsGenericMultiSelectCtrl($scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.label = $scope.label;
            vm.selected = [];

            vm.toggleSelect = toggleSelect;
        }

        function toggleSelect(item) {
            if (item.required) {
                return;
            }
            $timeout(function () {
                $scope.$apply(function () {
                    var exists = vm.selected.some(function (selection) {
                        return selection.value === item.value
                    });

                    if (exists) {
                        vm.selected = vm.selected.filter(function (selection) {
                            return item.value !== selection.value;
                        })
                    } else {
                        vm.selected.push(item);
                    }

                    $scope.onChange();
                    vm.setModelValue(vm.selected);
                })
            })
        }
    }
})();